import { useEffect, useRef, type RefObject } from 'react';
import { requireLegacy } from '../../legacy/legacyGlobals';

export interface LiveCounters {
  readingRef: RefObject<HTMLElement | null>;
  pagesRef: RefObject<HTMLElement | null>;
  /**
   * Stops the drift permanently — the landing does this when the language
   * sheet opens (and never restarts it unless the screen repaints), so
   * closing the sheet without choosing leaves the counters frozen.
   */
  stopDrift: () => void;
}

/**
 * The landing's simulated live counters (readers + pages): the suite's
 * countUp ease-in to the base figures, then a 2.3-second random drift.
 * The khatams stat is NOT driven here any more — it shows the campaign's
 * completed-khatam count and stays consistent with the thermometer.
 */
export function useLiveCounters(): LiveCounters {
  const readingRef = useRef<HTMLElement>(null);
  const pagesRef = useRef<HTMLElement>(null);
  const driftRef = useRef<number | null>(null);

  useEffect(() => {
    const countUp = requireLegacy('countUp');
    const reading = readingRef.current!;
    const pages = pagesRef.current!;
    countUp(reading, 8431, 1500);
    countUp(pages, 412806, 1600);
    let r = 8431, pg = 412806;
    const drift = window.setInterval(() => {
      r += Math.floor(Math.random() * 9) - 3;
      pg += 2 + Math.floor(Math.random() * 7);
      reading.textContent = r.toLocaleString('en-US');
      pages.textContent = pg.toLocaleString('en-US');
    }, 2300);
    driftRef.current = drift;
    return () => window.clearInterval(drift);
  }, []);

  const stopDrift = () => {
    if (driftRef.current != null) {
      window.clearInterval(driftRef.current);
      driftRef.current = null;
    }
  };

  return { readingRef, pagesRef, stopDrift };
}
